module.exports = __webpack_public_path__ + "static/media/SAJ_02.71acbe95.jpeg";